// Interne Module
import { replaceSpecialChars } from '@/_helper/mapper';

export function chipClass(str) {
    return replaceSpecialChars(str).toLowerCase().replaceAll(',', '').replaceAll(' ', '-').replace(/-+/g, '-');
}
